import { 
  JOB_LIST, 
  JOB_DETAIL, 
  JOB_EDIT,
  DELETE_JOB_SUCCESS,
} from "../actions/ActionType";

const INITIAL_STATE = {
  list: [],
  detail: {},
  edit: false,
  delete_success: false,
  unauthorize: false
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case JOB_LIST:
      return { ...state, list: action.payload };
    case JOB_DETAIL:
      return { ...state, detail: action.payload };
    case JOB_EDIT:
      return { ...state, edit: action.payload}
    case DELETE_JOB_SUCCESS:
      return {...state, edit: action.payload}
    case "job-unauthorize": 
      return {...state, unauthorize: action.payload}
    default:
      return state;
  }
};
